import { Component } from 'react';
import ChatList from './ChatList'
import ChatDetail from './ChatDetail'

export default class Chat extends Component {
    constructor() {
        super();
        this.state = {
            chatId: this.parseChatId()
        }
      }

      componentDidUpdate() {
          let chatId = this.parseChatId()

          if (chatId !== this.state.chatId) {
            this.setState({ chatId })
          }
      }

	// Parse chat id from url path
	parseChatId() {
		let url = window.location.href
		let chatId = url.split("/")[4]
		return chatId
	}

    render() {
        if (this.state.chatId) {
            return <ChatDetail chatId = {this.state.chatId} />
        }
        else {
            return <ChatList />
        }
    }
}